'use client';

import React from 'react';
import Spinner from './Spinner';

const ApplicationLoading: React.FC = () => (
  <div className="h-full bg-[var(--p-color-bg)]">
    <Spinner accessibilityLabel="Application is loading" />
  </div>
);

export default ApplicationLoading;
